<template>
  <div class="content">
    <div class="row">
      <base-button @click="goForm" type="success">등록</base-button>
    </div>
    <div class="row">
      <el-table :data="data">
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
        <el-table-column :min-width="100" align="right" label="상세보기">
          <div slot-scope="props">
            <base-button @click.native="showUserDetail(props.row.id)" type="warning" size="sm" icon>
              <i class="tim-icons icon-zoom-split" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import { BasePagination } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
  },
  async created() {
    await this.getAdminUsers();
  },
  data() {
    return {
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 100,
        },
        {
          prop: "username",
          label: "운영자아이디",
          minWidth: 100,
        },
        {
          prop: "name",
          label: "이름",
          minWidth: 100,
        },
        {
          prop: "email",
          label: "이메일",
          minWidth: 100,
        },
        {
          prop: "regDate",
          label: "가입일",
          minWidth: 100,
        },
      ],

      data: [],

      currentPage: 1,
      totalPages: null,
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getAdminUsers(this.currentPage);
      },
    },
  },
  methods: {
    async getAdminUsers(page) {
      const params = {};
      params.currentPage = page ? page : 1;

      return this.$axios.get("/adminUsers", { params }).then((res) => {
        this.data = res.data.data.adminUsers.map((user) => {
          user.regDate = formatDateTime(user.regTime, "YYYY-MM-DD");
          return user;
        });
        this.totalPages = Number(res.data.data.page);
      });
    },

    goForm() {
      this.$router.push(`/adminUser/adminUserManageForm`);
    },
    showUserDetail(id) {
      this.$router.push(`/adminUser/adminUserManageForm?id=${id}`);
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
